import axios from "axios";

const serverUrl = process.env.REACT_APP_BASE_URL;
const serverApiKey = process.env.REACT_APP_API_KEY;

export async function getCustomer(userEmail: string) {
  try {
    const response = await axios.get(`${serverUrl}/user/customer`, {
      headers: {
        "X-API-Key": serverApiKey,
        "X-User-Email":userEmail
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching subscription:", error);
    throw error;
  }
}

export async function getCustomerSubscription(userEmail: string) {
  try {
    const response = await axios.get(`${serverUrl}/user/customer/subscriptions`, {
      headers: {
        "X-API-Key": serverApiKey,
        "X-User-Email":userEmail
      },
    });
    
    return response.data;

  } catch (error: any) {
    console.error("Error fetching subscription:", error);
    throw error;
  }
}

export async function createCustomer(userEmail: string)
{  
  try{
    const response = await axios.post(`${serverUrl}/user/customer`,null,
      {      
        headers: {
          "X-API-Key": serverApiKey,
          "X-User-Email":userEmail
      },
    });

    return response.data;
  }
  catch (error: any) {
    console.error("Error creating customer:", error);
    throw error;
  }
}


export async function getActiveSubscriptions(userEmail: string)
{
  try {
    const response = await axios.get(`${serverUrl}/subscription/active`, {
      headers: {
        "X-API-Key": serverApiKey,
        "X-User-Email":userEmail
      },
    });
    
    return response.data;

  } catch (error: any) {
    console.error("Error fetching subscription:", error);
    throw error;
  }
}